// TODO: remove jquery from here and from webpack config once CONFDEV-52616 is done.
// eslint-disable-next-line no-restricted-imports
import $ from 'jquery';
import idx from 'idx';
import window from 'window-or-global';
import { bind } from '@confluence-classic/confluence-event_DO_NOT_USE';

import { getApolloClient } from '@confluence/graphql';
import { getSessionData } from '@confluence/session-data';
import { setUserAgent, isIE } from '@confluence/browser-helper';

import { getRte, getAutocompleter } from '../../../tech-debt/facades/editor';
import { getWindow } from '../../../tech-debt/facades/window';
import logIfNotProduction from '../../../lib/log-if-not-prod';
import getMentionsConfig from '../confluence-mentions-config';

import MentionsPickerAdapter from './mentions-picker-adapter';
import AutoCompleteManager from './autocomplete-manager';
import { SpaceIDQuery as GRAPH_QUERY_SPACE_ID } from './SpaceIDQuery.graphql.js';

setUserAgent(getWindow().navigator.userAgent);

const KEY_TRIGGER = '@';
const COMMAND_NAME = 'mceConfInsertFabricMentionsAutocomplete';

let mentionsAutoComplete;
let mentionConfig;

function handleGetMentionsConfigError(error) {
	if (process.env.NODE_ENV !== 'production') {
		console.error('Unable to initialise mentions config ', error);
	}
}

function handleMissingSpaceId(error) {
	if (process.env.NODE_ENV !== 'production') {
		console.warn(
			'There was an error getting mentions config with space id. Trying without space id',
			error,
		);
	}
}

function handleGetCloudIdError(error) {
	if (process.env.NODE_ENV !== 'production') {
		console.error('There was an error retrieving cloudId ', error);
	}
}

function isAtKey(event) {
	return (
		event &&
		event.shiftKey &&
		!event.ctrlKey &&
		!event.altKey &&
		!event.altGraphKey &&
		!event.metaKey &&
		event.which === 64
	);
}

function activateMentions() {
	if ((!mentionsAutoComplete.control || mentionsAutoComplete.control.dying) && mentionConfig) {
		mentionsAutoComplete.start();
		if (mentionsAutoComplete.control) {
			const spanAutoComplete = mentionsAutoComplete.control.getContainer();
			spanAutoComplete && spanAutoComplete.addClass('fabric-mentions-autocomplete');

			/* istanbul ignore next */
			function update(data) {
				mentionsAutoComplete &&
					mentionsAutoComplete.control &&
					mentionsAutoComplete.control.update(data);
			}

			/* istanbul ignore next */
			function die() {
				mentionsAutoComplete && mentionsAutoComplete.control && mentionsAutoComplete.control.die();
			}
			mentionsAutoComplete.picker = new MentionsPickerAdapter({
				mentionResource: mentionConfig.mentionResource,
				presenceResource: mentionConfig.presenceResource,
				anchor: spanAutoComplete,
				query: mentionsAutoComplete.control.word,
				update,
				die,
				contextIdentifier: mentionConfig.contextIdentifier,
			});

			return true;
		}
	}

	return false;
}

function initAutoCompleteObject() {
	// Mention Autocomplete settings.
	getAutocompleter().Settings[KEY_TRIGGER] = {
		ch: KEY_TRIGGER,
		endChars: [],

		onTextChange(trigger, text) {
			if (mentionsAutoComplete.picker.onTextChange) {
				mentionsAutoComplete.picker.onTextChange(text);
			}
		},
		isDataValid() {
			return true;
		},
		onKeyUp() {
			if (mentionsAutoComplete.picker.onKeyUp) {
				mentionsAutoComplete.picker.onKeyUp();
			}
		},
		onKeyDown() {
			if (mentionsAutoComplete.picker.onKeyDown) {
				mentionsAutoComplete.picker.onKeyDown();
			}
		},
		onKeyEnter() {
			if (mentionsAutoComplete.picker.onKeyEnter) {
				mentionsAutoComplete.picker.onKeyEnter();
			}
		},
		onKeyTab() {
			if (mentionsAutoComplete.picker.onKeyTab) {
				mentionsAutoComplete.picker.onKeyTab();
			}
		},
		update(autoCompleteControl, data) {
			if (mentionsAutoComplete.picker.update) {
				mentionsAutoComplete.picker.update(data);
			}
			if (mentionsAutoComplete.picker.die) {
				mentionsAutoComplete.picker.die();
			}
			//CONFDEV-2263: must kill mentionsAutoComplete if not, some key handles of mentionsAutoComplete is still remaining
			mentionsAutoComplete.reset();
		},
	};

	const settingsOfAutoCompleteManager = {
		leadingChar: KEY_TRIGGER, //leadingChar must the same as key trigger

		onBeforeDie() {
			mentionsAutoComplete.picker && mentionsAutoComplete.picker.die();

			//after inserting date lozenge, user press Escape or click outside after that to cancel
			//we will delete current date text was inserted before
			if (mentionsAutoComplete.control) {
				const $container = $(mentionsAutoComplete.control.getContainer());
				const $inserting = $container.find('.inserting');

				/* istanbul ignore else */
				if (!$container.hasClass('isDirty')) {
					$inserting.closest('#autocomplete-search-text').remove();
				}
			}
		},

		onBeforeEnter(undoManager) {
			if (mentionsAutoComplete.control) {
				const $searchText = $(mentionsAutoComplete.control.getContainer()).find(
					'#autocomplete-search-text',
				);

				// CONFDEV-43035 Preserve any text typed to filter the mentions autocomplete dropdown
				if ($searchText.text().length > 0) {
					$searchText.prepend(KEY_TRIGGER);
					undoManager && typeof undoManager.add === 'function' && undoManager.add();
				}
			}
		},
	};

	mentionsAutoComplete = new AutoCompleteManager(settingsOfAutoCompleteManager);
}

function registerTriggerAt() {
	//register handler for trigger '@'
	bind('confluence.editor.registerHandlers', (e, data) => {
		const handlerManager = data.handlerManager;
		const ed = data.ed;
		const createHandler = data.createHandler;

		const handleAt = createHandler(
			/(?:\s|\xA0|^|\ufeff|\u200b)()$/,
			(...args) => {
				logIfNotProduction('=== activating mentions via handler....', args);
				activateMentions();
			},
			true, //swallow trigger char
			'#autocomplete', //do not trigger inside #autocomplete
		);

		ed.onKeyPress.addToTop((ed, e) => {
			//We do not want to override any browser shortcuts but we can't
			//catch alt and ctrl keys due to other keyboard layouts like german
			if (e.metaKey) {
				return true;
			}

			const ch = isIE() ? e.keyCode : e.which;

			const character = String.fromCharCode(ch); // charCode back to '@'
			if (character === '@') {
				activateMentions() && window.tinymce.dom.Event.cancel(e);
				return false;
			}

			return true;
		});

		handlerManager.registerHandler('@'.charCodeAt(0), handleAt);
	});
}

const getSpaceID = (spaceKey) =>
	getApolloClient().query({
		query: GRAPH_QUERY_SPACE_ID,
		variables: { spaceKey },
	});

/**
 * Sets the mentions config.
 * It will try to set the container ID inferring the space key from the url and fetching the ID from graphQL.
 * If it cannot get a space key will leave contaniner ID empty.
 * @private
 */
function _setMentionsConfig(mentionContext) {
	const currentUrl = window.location.href;
	const matches = currentUrl.match(/\/spaces\/([^/]+)\//);
	const spaceKey = matches ? matches[1] : null;

	getSessionData()
		.then(({ cloudId }) =>
			getSpaceID(spaceKey)
				.then((response) =>
					getMentionsConfig(cloudId, null, {
						...mentionContext,
						spaceId: response.data.space.id,
					})
						.then((config) => (mentionConfig = config))
						.catch((err) => handleGetMentionsConfigError(err)),
				)
				.catch((error) => {
					handleMissingSpaceId(error);
					getMentionsConfig(cloudId)
						.then((config) => (mentionConfig = config))
						.catch((err) => handleGetMentionsConfigError(err));
				}),
		)
		.catch((error) => handleGetCloudIdError(error));
}

const getCommentId = (ed) => {
	const id = idx(ed, (_) => _.formElement.offsetParent.id) || '';
	return id.includes('comment-') || id.includes('addcomment') ? id.replace('comment-', '') : null;
};

const getContentId = (ed) => idx(ed, (_) => _.settings.page_id);

// Not converted to a ES2015 because tinymce expect an object
const plugin = {
	init(ed) {
		const rte = getRte();
		logIfNotProduction('Initialising the Mentions plugin');
		_setMentionsConfig({
			contentId: getContentId(ed),
			commentId: getCommentId(ed),
		});

		// Register the command so that it can be invoked by using window.tinymce.activeEditor.execCommand(COMMAND_NAME);
		ed.addCommand(COMMAND_NAME, activateMentions);

		initAutoCompleteObject(ed);
		registerTriggerAt(ed);

		// destroy Date AutoComplete when a context menu is shown
		ed.onContextMenu.add(() => {
			mentionsAutoComplete.reset();
		});

		// Insert button
		/* istanbul ignore next */
		$('#insertmention-button').click((e) => {
			// required to stop macro browser using the event (derp)
			e.stopPropagation();
			e.preventDefault();

			activateMentions();
		});

		// For templates
		bind('editor.text-placeholder.activated', (e, data) => {
			/* istanbul ignore else */
			if (data && data.placeholderType === 'mention') {
				/* istanbul ignore if */
				if (isAtKey(data.triggerEvent)) {
					// Avoid 2nd @
					window.tinymce.dom.Event.cancel(data.triggerEvent);
				}
				window.tinymce.execCommand('mceFocus', false, ed.id);
				activateMentions();
			}
		});

		if (rte.Placeholder && rte.Placeholder.addPlaceholderType) {
			rte.Placeholder.addPlaceholderType({
				type: 'mention',
				label: 'User mention',
				tooltip: 'Instructional text is replaced with suggested people when a person types.',
			});
		}
	},

	getInfo() {
		return {
			longname: 'Fabric Mentions',
			author: 'Atlassian',
			authorurl: 'http://www.atlassian.com',
			version: `${window.tinymce.majorVersion}.${window.tinymce.minorVersion}`,
		};
	},

	getServiceUrl() {
		return mentionConfig.mentionServiceUrl;
	},
};

export default plugin;
